import { render, staticRenderFns } from "./LcUser.vue?vue&type=template&id=21396f07&scoped=true"
import script from "./LcUser.vue?vue&type=script&lang=js"
export * from "./LcUser.vue?vue&type=script&lang=js"
import style0 from "./LcUser.vue?vue&type=style&index=0&id=21396f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21396f07",
  null
  
)

export default component.exports